import { DotLegalDeleteDialog, DotLegalInfoDialog } from "@dotlegal/dotlegal-ui-components";
import { Trans } from "react-i18next";
import { useTranslation } from "@localization/useTranslation";
import useDeleteInternalAssessmentGroup from "./DeleteInternalAssessmentGroupDialog.hooks";
import HighlightedName from "@common/components/HighlightedName";

export interface IDeleteInternalAssessmentGroupDialogProps {
    internalAssessmentGroupId: string;
    internalAssessmentGroupName: string;
    deadline: Date;
    canBeDeleted: boolean;
    onDialogClose: () => void;
    onDeleted: () => void;
}

function DeleteInternalAssessmentGroupDialog(props: IDeleteInternalAssessmentGroupDialogProps) {
    const { translateString, translateDate } = useTranslation();
    const { inProgress, confirmDelete, setConfirmDelete, deleteClick } = useDeleteInternalAssessmentGroup(props);

    const boldName = (i18nKey: string) => (
        <Trans
            i18nKey={i18nKey}
            values={{ name: props.internalAssessmentGroupName, deadline: translateDate(props.deadline) }}
            components={{
                wrapper: <HighlightedName />,
            }}
        />
    );

    // The backend refuses the delete outright while a child assessment is still in flight, so the reason is
    // explained here rather than letting the guard surface as an error.
    if (!props.canBeDeleted) {
        return (
            <DotLegalInfoDialog
                header={translateString("deleteInternalAssessmentGroup")}
                btnText={translateString("close")}
                content={boldName("internalAssessmentGroupCannotBeDeletedInfo")}
                onCloseDialog={props.onDialogClose}
                onBtnClick={props.onDialogClose}
            />
        );
    }

    return (
        <DotLegalDeleteDialog
            open
            headerText={translateString("deleteInternalAssessmentGroup")}
            alertBodyText={boldName("deleteInternalAssessmentGroupInfoText")}
            deleteBtnText={translateString("delete")}
            confirmLabel={translateString("deleteInternalAssessmentGroup")}
            cancelBtnText={""}
            warningTranslation={""}
            confirmDeleteRequired
            confirmDelete={confirmDelete}
            setConfirmDelete={setConfirmDelete}
            onDialogClose={props.onDialogClose}
            onOkClick={deleteClick}
            inProgress={inProgress}
        />
    );
}

export default DeleteInternalAssessmentGroupDialog;
